module.exports = __webpack_public_path__ + "static/media/notif-sound.00f8cd71.mp3";